/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Tool_CallingInputs */

const en_svchip_tool_calling = /** @type {(inputs: Svchip_Tool_CallingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool calling`)
};

const ar_svchip_tool_calling = /** @type {(inputs: Svchip_Tool_CallingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استدعاء الأدوات`)
};

const bn_svchip_tool_calling = /** @type {(inputs: Svchip_Tool_CallingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টুল কলিং`)
};

const de_svchip_tool_calling = /** @type {(inputs: Svchip_Tool_CallingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werkzeugaufruf`)
};

const es_svchip_tool_calling = /** @type {(inputs: Svchip_Tool_CallingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Llamada a herramienta`)
};

const fr_svchip_tool_calling = /** @type {(inputs: Svchip_Tool_CallingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appel d'outil`)
};

const pt_svchip_tool_calling = /** @type {(inputs: Svchip_Tool_CallingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chamada de ferramenta`)
};

const zh_svchip_tool_calling = /** @type {(inputs: Svchip_Tool_CallingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工具调用`)
};

const tr_svchip_tool_calling = /** @type {(inputs: Svchip_Tool_CallingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Araç çağırma`)
};

const ru_svchip_tool_calling = /** @type {(inputs: Svchip_Tool_CallingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вызов инструмента`)
};

const pl_svchip_tool_calling = /** @type {(inputs: Svchip_Tool_CallingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wywołanie narzędzia`)
};

/**
* | output |
* | --- |
* | "Tool calling" |
*
* @param {Svchip_Tool_CallingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_tool_calling = /** @type {((inputs?: Svchip_Tool_CallingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Tool_CallingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_tool_calling(inputs)
	if (locale === "bn") return bn_svchip_tool_calling(inputs)
	if (locale === "de") return de_svchip_tool_calling(inputs)
	if (locale === "es") return es_svchip_tool_calling(inputs)
	if (locale === "fr") return fr_svchip_tool_calling(inputs)
	if (locale === "pt") return pt_svchip_tool_calling(inputs)
	if (locale === "zh") return zh_svchip_tool_calling(inputs)
	if (locale === "tr") return tr_svchip_tool_calling(inputs)
	if (locale === "ru") return ru_svchip_tool_calling(inputs)
	if (locale === "pl") return pl_svchip_tool_calling(inputs)
	return en_svchip_tool_calling(inputs)
});